import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-privacynotice',
  templateUrl: './privacynotice.component.html',
})
export class PrivacyNoticeComponent implements OnInit {
  documentFolder = '';

  constructor(private _location: LocationStrategy, private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle('EY TP Benchmark | Privacy Notice');
    this.documentFolder = `${this._location.getBaseHref()}assets/PrivacyNoticeDoc/`;
  }

  scroll(element) {
    if (element != null) {
      element.scrollIntoView();
    }
  }
}
